import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TrackableItemQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type TrackableItemQuery = { __typename?: 'Query', trackableItem: { __typename?: 'TrackableItem', id: string, name: string, epc_tag: string, is_recalled: boolean, item_type: { __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null, category: Types.ItemTypeCategory, archived: boolean, epc_asset_id: number, weight: number } } };


export const TrackableItemDocument = gql`
    query TrackableItem($id: ID!) {
  trackableItem(id: $id) {
    id
    name
    epc_tag
    is_recalled
    item_type {
      id
      name
      image_url
      color_hex_code
      category
      archived
      epc_asset_id
      weight
    }
  }
}
    `;

/**
 * __useTrackableItemQuery__
 *
 * To run a query within a React component, call `useTrackableItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackableItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackableItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrackableItemQuery(baseOptions: Apollo.QueryHookOptions<TrackableItemQuery, TrackableItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackableItemQuery, TrackableItemQueryVariables>(TrackableItemDocument, options);
      }
export function useTrackableItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackableItemQuery, TrackableItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackableItemQuery, TrackableItemQueryVariables>(TrackableItemDocument, options);
        }
export type TrackableItemQueryHookResult = ReturnType<typeof useTrackableItemQuery>;
export type TrackableItemLazyQueryHookResult = ReturnType<typeof useTrackableItemLazyQuery>;
export type TrackableItemQueryResult = Apollo.QueryResult<TrackableItemQuery, TrackableItemQueryVariables>;